import React from 'react';
// import './WhyChoose.css';

import bgImage from '../media3/whychoose/card1bg.png';
import caseimg from '../media3/whychoose/case.svg';


const WhyChoose = () => {
  return (
    <section className="why-choose-section">
      <div className="container">
        <h1 className="section-titles">Why Choose SkinForge</h1>
        <p className="section-subtitle">
          The features that make SkinForge the premium destination for buying skin.
        </p>
        <div className="cards-row">

           <div
            className="card card-large"
            style={{
              width: "90%",
              height: "360px",
              borderRadius: "6px",
              backgroundImage: `url(${bgImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "#fff",
            }}
          >
            <div className="card-content" style={{ textAlign: "center" }}>
            </div>
          </div>

          <div className="whychoose-card2">
            <h2 className="percentage">89 %</h2>
            
            <p >
              Curated knives, gloves, and rare drops.
            </p>
          </div>
        </div>
        <div className="cards-row">
              <div className="whychoose-card3">
              <div className="card-header">
                <h3 className="card-heading-small">Live Market Data</h3>
                <h2 className="card-subheading">
                  Track real-time prices, rarity, and availability.
                </h2>
              </div>

              <div className="card-image">
                <img src={caseimg} alt="Live Market Data"/>
              </div>
            </div>

          <div className="whychoose-card4">
            <p className="card-quote">
              Designed with gamers in mind — smooth navigation, tailored picks,
              and optimized for the ultimate
            </p>
            <h4 className="card-label">Gamer-First Design</h4>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;